import React from "react";
import MobileRecording from "./mobileRecording";
import MobileRecordingHeader from "./mobileRecordingHeader";
import MobileContinueButton from "../button/mobileContinueButton";
import MobileCancelButton from "../button/mobileCancelButton";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

class MobileRecordingNfcReader extends MobileRecording {
    constructor(props) {
        super();
    }

    reader = null;

    componentDidMount = async () => {
        if ("NDEFReader" in window) {
            try {
                this.reader = new window.NDEFReader();
                await this.reader.scan();
                console.log("> Scan started");

                this.reader.addEventListener("reading", this.handleNfcReading);
                this.reader.addEventListener("error", this.handleNfcError);

                // reader.addEventListener("error", () => {
                //   // console.log(`Argh! ${error.message}`);
                //   console.log("Argh! ${error.message}");
                // });

                // reader.addEventListener("reading", ({ message, serialNumber }) => {
                //   alert(serialNumber);
                //   this.onChange(serialNumber);
                // });
            } catch (error) {
                alert(error);
            }
        } else {
            alert("Web NFC is not supported.");
        }
    };

    handleNfcReading = ({message, serialNumber}) => {
        let newSerialNumber = "";

        // Nummer konvertieren
        // alt: 12:34:56:78
        // neu: 78:56:34:12
        for (let i = serialNumber.length - 1; i > 0; i -= 3) {
            if (newSerialNumber.length > 0) {
                newSerialNumber += ":";
            }
            newSerialNumber += serialNumber.substring(i - 1, i + 1);
        }
        this.onChange(newSerialNumber);
        this.onFieldContinue();
    };

    handleNfcError = error => {
        alert("error: " + error);
    };

    componentWillUnmount() {
        if (this.reader) {
            this.reader.removeEventListener("reading", this.handleNfcReading);
            this.reader.removeEventListener("error", this.handleNfcError);
        }
    }

    render = () => {
        const {
            currentFlowChart,
            currentRecordingFlowChart,
            recordData
        } = this.props;

        let data = [];
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        const continueButtonDisabled = this.isContinueButtonDisabled(
            currentRecordingFlowChart,
            recordData
        );
        const selectionDisabled = this.isSelectionDisabled(
            currentRecordingFlowChart,
            recordData
        );

        columns = [
            {
                Header: (
                    <MobileRecordingHeader
                        title={currentFlowChart.title.text}
                        subTitle={
                            currentRecordingFlowChart.title.text +
                            ": " +
                            recordData.fields[
                                `${currentRecordingFlowChart.tableField}Display`
                                ]
                        }
                    />
                ),
                Cell: ({original}) => (
                    <button
                        className="btn btn-secondary btn-lg btn-block"
                        value={original.text}
                        onClick={() => {
                            this.onChange(original.text);
                        }}
                        disabled={selectionDisabled && !original.textAlwaysEnabled}
                    >
                        {original.text}
                    </button>
                ),
                Footer: () => (
                    <React.Fragment>
                        <div
                            className="btn-toolbar justify-content-between"
                            role="toolbar"
                            aria-label="Toolbar with button groups"
                        >
                            <MobileContinueButton
                                onClick={() => {
                                    this.onFieldContinue();
                                }}
                                disabled={continueButtonDisabled}
                                title={{text: "Weiter"}}
                            />
                            <MobileCancelButton
                                onClick={() => {
                                    this.onFieldCancel();
                                }}
                                title={{text: "Abbrechen"}}
                            />
                        </div>
                    </React.Fragment>
                )
            }
        ];

        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingNfcReader;
